<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { getTemplateService } from 'src/helpers/xt1_helpers/template_helpers';
	//Services
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	//Design system components
	import { Text, Token, Loader } from '@Shelly/shelly-design-system';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';
	//Types
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	import type { Device } from 'src/types/Device';

	export let device: Device;

	let waitForResponse = false;
	let targetLock = false;
	let value: 'C' | 'F' = 'C';

	const onSettingChange = (device: Device) => {
		const _value = (getTemplateService(device)?.settings?.temp_unit || 'C').toUpperCase();
		if (!waitForResponse && !targetLock && value !== _value) {
			value = _value;
		}
		if (targetLock && value == _value) {
			targetLock = false;
		}
	};

	const saveValue = async () => {
		waitForResponse = true;
		const _value = value;
		const res: SettingRequest = await gen2Request(device, 'Service.SetConfig', {
			id: 0,
			config: {
				temp_unit: value,
			},
		});
		if (res?.isok) {
			targetLock = true;
			value = _value;
		}
		onSettingsResponse(res, device);
		waitForResponse = false;
	};

	$: onSettingChange(device);
</script>

<Text styleType="body-small" class="mb-s">
	{$format('select_temperature_units', {
		default: 'Choose temperature units:',
	})}
</Text>

<div
	class={classMap({
		'd-flex': true,
		'justify-content-center': waitForResponse,
	})}
>
	{#if waitForResponse}
		<Loader size="m" class="align-self-center" />
	{:else}
		<Token
			id="token-jqcx85y"
			selected={value === 'C'}
			size="m"
			title="°C"
			class="mr-s"
			on:click={() => {
				value = 'C';
				saveValue();
			}}
		/>
		<Token
			id="token-1uqfi63"
			selected={value === 'F'}
			size="m"
			title="°F"
			on:click={() => {
				value = 'F';
				saveValue();
			}}
		/>
	{/if}
</div>
